import React from 'react'

function OrderPicking() {
  return (
    <div className="card">
      <div style={{ padding: 'var(--space-6)', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 'var(--space-4)' }}>📦</div>
        <h2 style={{ marginBottom: 'var(--space-2)' }}>Order Picking</h2>
        <p className="text-muted">
          This feature is coming soon. Order picking workflow will be available here.
        </p>
      </div>
    </div>
  )
}

export default OrderPicking
